import { faArrowUpRightFromSquare, faChevronLeft, faChevronRight, faXmark } from '@fortawesome/free-solid-svg-icons';

import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { MessageBannerService, NotificationService } from '@core/services';

import { BannerMessage } from '@shared/models';

const MESSAGE_ROTATION_INTERVAL_MS = 5000;

@Component({
    selector: 'app-message-banner',
    templateUrl: './message-banner.component.html',
    styleUrls: ['./message-banner.component.scss'],
    animations: [
        trigger('slideInLeft', [
            transition(':enter', [
                style({ transform: 'translateX(-100%)' }),
                animate('1000ms ease-in', style({ transform: 'translateX(0)' })),
            ]),
        ]),
    ],
    standalone: false,
})
export class MessageBannerComponent implements OnInit, OnDestroy {
    constructor(private bannerService: MessageBannerService, private notificationService: NotificationService) {}

    messages = [] as BannerMessage[];
    messagesVisible = false;
    faXmark = faXmark;
    previousIcon = faChevronLeft;
    nextIcon = faChevronRight;
    faArrowUpRightFromSquare = faArrowUpRightFromSquare;
    currentIndex = 0;
    timer?: number;

    ngOnInit(): void {
        this.bannerService.fetchBannerMessages().subscribe({
            next: (messages) => {
                this.messages = messages;
                if (this.messages.length) {
                    this.messagesVisible = true;
                }
                if (this.messages.length > 1) {
                    this.resetTimer();
                }
            },
            error: (err) => {
                console.error('Failed retrieving notifications', err);
                this.notificationService.errorMessage(
                    $localize`:@@messageBanner.error:Er ging iets mis bij het ophalen van de bannerberichten`,
                );
            },
        });
    }

    ngOnDestroy(): void {
        window.clearInterval(this.timer);
    }

    hideMessages(): void {
        this.messagesVisible = false;
        window.clearInterval(this.timer);
    }

    resetTimer(): void {
        window.clearInterval(this.timer);
        this.timer = window.setInterval(() => {
            this.currentIndex = (this.currentIndex + 1) % this.messages.length;
        }, MESSAGE_ROTATION_INTERVAL_MS);
    }

    showNext(): void {
        if (this.messages.length > 0) {
            this.currentIndex = (this.currentIndex + 1) % this.messages.length;
            this.resetTimer();
        }
    }

    showPrevious(): void {
        if (this.messages.length > 0) {
            // TS/JS modulo yields negatives for negative numbers, hence the addition
            this.currentIndex = (this.currentIndex + this.messages.length - 1) % this.messages.length;
            this.resetTimer();
        }
    }
}
